import { useContext } from 'react'
import { LoadingStateContext } from './loadingContexts'

export const useLoadingState = () => {
  const context = useContext(LoadingStateContext)
  if (context === undefined) {
    throw new Error('useLoadingState must be used within a LoadingProvider')
  }
  return context
}
